import { createContext, useContext } from "react";
import type { SessionResponse } from "../api/session";

/** The shell's live session, including role-only updates that keep the page mounted. */
export const SessionContext = createContext<SessionResponse | null>(null);

export const useSession = (): SessionResponse | null => useContext(SessionContext);
